module.exports = __webpack_public_path__ + "assets/ic_tree27.6476873d.svg";